export const _googleIdentityOAuthRedirectUrl = () => {
  const baseUrl = window.location.origin;

  return `${baseUrl}/google-oauth-redirect`;
};
